<template>
  <b-container style="margin-top:15px">
    <b-row v-loading="loading">
      <b-card-group deck>
        <b-card header="Ödeme Sistemi Ekle" header-tag="header">
            <b-row>
              <b-col cols="3">
                <b-form-group label="İsim">
                  <b-form-input size="sm" v-model="form.name" placeholder="İsim"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Açıklama">
                  <b-form-input size="sm" v-model="form.description" placeholder="Açıklama"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                <b-form-group label="Slug">
                  <b-form-input size="sm" v-model="form.slug" placeholder="Slug"></b-form-input>
                </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group label="Durum">
                    <b-form-select size="sm" v-model="form.is_active" class="form-control mb-3 form-control-sm">
                      <b-form-select-option disabled :value="null">Seçiniz</b-form-select-option>
                      <b-form-select-option :value="1">Aktif</b-form-select-option>
                      <b-form-select-option :value="0">Pasif</b-form-select-option>
                    </b-form-select>
                  </b-form-group>
              </b-col>
              <b-col cols="12">
                  <b-form-group label="Parametreler">
                    <b-col style="margin-bottom:15px" span="24" v-for="(item,key) in form.parameters" :key="key">
                      <h5 style="margin-left:5px"><b style="font-size:12px; color:var(--color)">{{ key + 1 }}. parameters</b></h5>
                      <b-row>
                        <b-col cols="2">
                            <b-form-input size="sm" required placeholder="Name yazınız" v-model="form.parameters[key]"></b-form-input>
                        </b-col>
                        <b-col cols="1" v-if="(_.size(form.parameters) - 1) == key">
                            <b-button @click="addRow()" size="sm" variant="dark" style="width:100%">Satır Ekle</b-button>
                        </b-col>
                        <b-col cols="1" v-if="key != 0">
                            <b-button @click="removeRow(key)" size="sm" variant="danger" style="width:100%">Satırı Sil</b-button>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-form-group>
              </b-col>
              <b-col cols="3">
                  <b-form-group style="margin-top:29px">
                    <b-button @click="send()" style="width:100%" variant="primary" size="sm">Ekle</b-button>
                  </b-form-group>
              </b-col>
            </b-row>
        </b-card>
      </b-card-group>
    </b-row>
  </b-container>
</template>

<script>
  export default{
    name: 'PaymentsCreate',
    data(){
      return{
        loading: false,
        payments:[],
        form:{
          name:null,
          description:null,
          parameters:[''],
          slug:null,
          is_active:null,
        }
      }
    },
    created(){
    },
    created(){
    },
    methods:{
      addRow(){
        this.form.parameters.push('')
      },
      removeRow(key){
        this.form.parameters.splice(key, 1)
      },
      send(){
        this.loading = true;
        axios.post('/payment/create', this.form)
        .then((response) => {
            this.$store.dispatch('alert/message', { type: 'warning', title: 'Ekleme Başarılı'});
            this.$router.push({name: 'Payments'});
        })
        .catch((err) => {
        })
        .finally(()=>{
            this.loading = false;
        })
      },
    }
  }
</script>